// src/layouts/AppLayout.tsx
import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import MainView from "../components/MainView";
import { UIProvider } from "../context/UIContext";
import { useAuth } from "../context/AuthContext";
import { createSignalRConnection, getConnection } from "../api/signalRClient";
import { HubConnectionState } from "@microsoft/signalr";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
//import logo from "/logo.png"; 
import { useUI } from "../context/UIContext";

// ✅ NEW — detect mobile width
/*const useIsMobile = () => {
  const [mobile, setMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return mobile;
};*/



const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 767px)").matches
  );

  useEffect(() => {
    const media = window.matchMedia("(max-width: 767px)");
    const listener = (e: MediaQueryListEvent) => setIsMobile(e.matches);

    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, []);

  return isMobile;
};


function InnerLayout() {
  const { token, logout,initialized  } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const navigate = useNavigate();

    // ✅ NEW — controls whether MainView is visible on mobile
  //const [showMain, setShowMain] = useState(false);

  
const isMobile = useIsMobile();
 
 
  
const { popUIState,selectedProjectId,viewMode,resetUI, isRestored  } = useUI(); // ✅ ADD THIS LINE HERE setViewMode





/*const showMain =
  !isMobile ||
 
  viewMode !== "project-chat";*/
//both mobile and desktop screen project dashboard visible
const showMain =
  !isMobile || 

  (isMobile && selectedProjectId !== null);

  /*const showMain =
  !isMobile ||
  selectedProjectId !== null ||
  selectedIssueId !== null;*/

 /* const showMain =
  !isMobile ||
  selectedProjectId !== null */
 // selectedIssueId !== null;

/*const showMain =
  !isMobile || selectedProjectId !== null;*/
  
const canRender = initialized && isRestored;



  /** ───────────────────────────────────────────
   *  SignalR Lifecycle
   *  Start after login, stop after logout
   *  ───────────────────────────────────────────*/
  useEffect(() => {
  // If no token → ensure connection is stopped
  if (!token) {
    try {
      getConnection()?.stop();
    } catch {}
    return;
  }

  let conn = getConnection();

  // If no connection OR it's safely disconnected → create/start
  if (!conn || conn.state === HubConnectionState.Disconnected) {

    conn = createSignalRConnection();

    conn
      .start()
      .then(() => {
        console.log("✅ SignalR connected"); 

        // attach listener safely
        conn?.on("ReceiveNotification", (message: string) => {
          toast(message);
        });
      })
      .catch((err) => {
        console.error("❌ SignalR start failed:", err);
      });
  }

  // Cleanup on component unmount
  return () => {
    try {
      getConnection()?.stop();
    } catch {}
  };
}, [token]);





  const handleBack = () => {
    
    popUIState();
};

/*const handleBack = () => {
  //const prev = popUIState();
     popUIState();

   // ✅ Mobile safety: never exit project accidentally
  if (isMobile && selectedProjectId && !viewMode) {
    setViewMode("project-dashboard");
  }
};*/







  /** ───────────────────────────────────────────
   *  Handle Logout
   *  ───────────────────────────────────────────*/
  const handleLogout = () => {
    try {
      getConnection()?.stop();
    } catch {}
    resetUI();        // ✅ THIS IS THE FIX
    logout();
    navigate("/login");
  };

  //w-80 bg-white border-r z-40 h-full overflow-hidden (aside classname old css style)

  //10-02-2026 old line flex h-screen bg-gray-50 text-gray-900 overflow-hidden
  //2nd <div className="flex h-screen bg-gray-50 text-gray-900">
  return (
  
   // <div className="flex h-screen bg-gray-50 text-gray-900">
      <div className="flex h-dvh bg-gray-50 text-gray-900">

   {/*<div className="flex h-screen bg-gray-50 text-gray-900">*/}

   



        

      {canRender && (!isMobile || !showMain) && (
       
      //  <aside className="w-full md:w-80 bg-white border-r z-40 h-full overflow-hidden">
      <aside className="w-full md:w-80 bg-white border-r z-40 h-full">

          <Sidebar />

        </aside>
      )}

      {/* ✅ Main only on desktop OR mobile-when-selected */}
      {canRender && (!isMobile || showMain) && (
      // <main className="flex-1 overflow-hidden">
          <main className="flex-1 min-w-0">
          



          {/* ✅ Pass control to MainView */}
          <MainView
            isMobile={isMobile}
            onBack={handleBack}
                    
              

          />
        </main>
      )}

      {!canRender && (
  <div className="flex-1 flex items-center justify-center text-gray-500">
    Loading…
  </div>
)}
    </div>
  );
}

/** ───────────────────────────────────────────
 *  Wrap layout inside UIProvider
 *  ───────────────────────────────────────────*/
export default function AppLayoutWrapper() {
  return (
    <UIProvider>
      <InnerLayout />
    </UIProvider>
  );
}
